import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const PropertyContext = createContext(null);

export function PropertyProvider({ children }) {
  const [properties, setProperties] = useState([]);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem("aqar_selected_property") || "all");

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/properties");
      setProperties(data);
      // If current selection is invalid, keep "all"
      if (selectedId !== "all" && !data.find((p) => p.id === selectedId)) {
        setSelectedId("all");
      }
    } catch { /* ignored */ }
  }, [selectedId]);

  useEffect(() => { load(); }, [load]);

  const setSelected = (id) => {
    setSelectedId(id);
    localStorage.setItem("aqar_selected_property", id);
  };

  const approvedProperties = properties.filter((p) => p.is_approved !== false);
  const currentPropertyId = selectedId === "all" ? null : selectedId;
  const currentProperty = properties.find((p) => p.id === selectedId) || null;

  return (
    <PropertyContext.Provider value={{
      properties, approvedProperties, selectedId, setSelected,
      currentPropertyId, currentProperty, reload: load,
    }}>
      {children}
    </PropertyContext.Provider>
  );
}

export function useProperties() {
  const ctx = useContext(PropertyContext);
  if (!ctx) throw new Error("useProperties must be used inside PropertyProvider");
  return ctx;
}
